import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ZenSnackbarComponent } from '../components/zen-snackbar/zen-snackbar.component';
import { ZenCDKService } from 'src/app/shared/Theme/services/zen-cdk.service';
import { ComponentPortal } from '@angular/cdk/portal';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root'
})
export class ZenSnackbarService {
  innerRoute$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  messages: BehaviorSubject<any> = new BehaviorSubject({});
  readonly messages$ = this.messages.asObservable();

  private subject = new Subject<any>();

  snackBar(message: ZenSnackBarOptions) {
    this.openSnackBar(message);
  }

  error(message: string, delay?: number) {
    this.openSnackBar({ message: message, delay: delay, type: ZenSnackBarTypes.Error });
  }
  success(message: string, delay?: number) {
    this.openSnackBar({ message: message, delay: delay, type: ZenSnackBarTypes.Success });
  }
  info(message: string, delay?: number) {
    this.openSnackBar({ message: message, delay: delay, type: ZenSnackBarTypes.Info });
  }
  warning(message: string, delay?: number) {
    this.openSnackBar({ message: message, delay: delay, type: ZenSnackBarTypes.Warning });
  }


  getSnackBar$ = this.subject.asObservable();
  openSnackBar(data) {
    this.messages.next(data);
  }
  clearSnackBar() {
    this.messages.next({});
  }
}

export interface ZenSnackBarOptions {
  message: string;
  delay?: number;
  type?: ZenSnackBarTypes;
}

export enum ZenSnackBarTypes {
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Error = 'error',
}
